export const STICKY_BANNER_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom'
}
